import { Classes, Divider } from "@blueprintjs/core";
import { PlanrPopover } from "modules/common/components/planr/popover/Popover";
import { observer } from "mobx-react";
import { GeneralIcon } from "modules/common/components/planr/icon/Generalcon";
import { AnnounceType } from "modules/root/models/announce";
import React from "react";
import styles from "./AppVersion.module.scss";

export const AppAnnounce = observer(({ announces }: AppAnnounceProps) => {
    const last = announces.length - 1;

    if (!announces.length) {
        return null;
    }

    return (
        <PlanrPopover
            enforceFocus={false}
            isOpen={undefined}
            className="app-announce"
            content={
                <div className={`${styles.announces} ${Classes.ELEVATION_2}`}>
                    {announces.map((item, index) => (
                        <div key={item.name}>
                            <h3 className={styles.title}>{item.name}</h3>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: item.description,
                                }}
                            />
                            {index < last && <Divider />}
                        </div>
                    ))}
                </div>
            }
        >
            <button type="button" className={styles.announce} title="Анонсы">
                <span>Анонсы</span>
                <GeneralIcon type="general-chevron-down" size={12} className={styles.chevron} />
            </button>
        </PlanrPopover>
    );
});

interface AppAnnounceProps {
    announces: AnnounceType[];
}
